import React__default from 'react';
import clsx from 'clsx';
import { NavLinkButton } from './NavLinkButton.component.js';
import { getLinkClassName } from './utils/getLinkClassName.js';
import styles from './LeftNavAppMenu.module.scss.js';

var SubMenu = function (_a) {
    var link = _a.link, selectedNavId = _a.selectedNavId, handleSelectLink = _a.handleSelectLink;
    if (!link.subLinks.length) {
        return null;
    }
    var className = clsx(styles.VerticalSubNav, (link.isActive || link.id === selectedNavId) &&
        styles.VerticalSubNav___active);
    return (React__default.createElement("ul", { className: className }, link.subLinks.map(function (subLink) { return (React__default.createElement("li", { className: styles.SubLinkWrapper, key: subLink.id },
        React__default.createElement("div", { className: getLinkClassName(subLink, 'SubLinkContainer', subLink.className) },
            React__default.createElement(NavLinkButton, { className: getLinkClassName(subLink, 'SubNavLink', subLink.className, styles.SubNavLink), link: subLink, onClick: handleSelectLink }, subLink.displayName)))); })));
};
SubMenu.displayName = 'SubMenu';

export { SubMenu };
